import image1 from "../assets/img/portfolio/portfolio-1.jpg";
import image2 from "../assets/img/portfolio/portfolio-2.jpg";
import image3 from "../assets/img/portfolio/portfolio-3.jpg";
import image4 from "../assets/img/portfolio/portfolio-4.jpg";
import image5 from "../assets/img/portfolio/portfolio-5.jpg";

const historyData = [
    {
        id: 'otokoc-osmangazi',
        title: 'Otokoç İkinci El Osmangazi Expertiz Alanı Tadilat İşi',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '20.01.2026',
        endDate: '28.02.2026',
        date: '2026',
        image: image1
    },
    {
        id: 'ford-eskisehir-aritma-elektrik',
        title: 'Ford Eskişehir Arıtma Tesisi Elektrik İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '15.01.2026',
        endDate: 'Devam Ediyor',
        date: '2026',
        image: image1
    },
    {
        id: 'ford-eskisehir-aritma-mimari',
        title: 'Ford Eskişehir Arıtma Tesisi Mimari İşler',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '04.12.2025',
        endDate: 'Devam Ediyor',
        date: '2025',
        image: image1
    },
    {
        id: 'ford-eskisehir-aritma-mekanik',
        title: 'Ford Eskişehir Arıtma Tesisi Mekanik İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.12.2025',
        endDate: 'Devam Ediyor',
        date: '2025',
        image: image1
    },
    {
        id: 'ford-otosan-yenikoy',
        title: 'Ford Otosan Yeniköy Montaj Binası Buffer Arakat Yapılması',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.12.2025',
        endDate: 'Devam Ediyor',
        date: '2025',
        image: image1
    },
    {
        id: 'ford-otosan-eskisehir',
        title: 'Ford Otosan Eskişehir Arıtma Binası Kaba İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '18.06.2025',
        endDate: '31.01.2026',
        date: '2025',
        image: image1
    },
    {
        id: 'ford-inonu-yangin',
        title: 'Ford İnönü Yangın Pompa Dairesi Altyapı Deplase İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '21.05.2025',
        endDate: '08.09.2025',
        date: '2025',
        image: image1
    },
    {
        id: 'ford-inonu-yangin',
        title: 'Ford İnönü Yangın Pompa Dairesi Altyapı Deplase İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '21.05.2025',
        endDate: '08.09.2025',
        date: '2025',
        image: image1
    },
    {
        id: 'ford-eskisehir-deprem',
        title: 'Ford Eskişehir Yerleşkesi Deprem Güçlendirme İnşaat İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '02.01.2025',
        endDate: '30.09.2025',
        date: '2025',
        image: image1
    },
    {
        id: 'ford-sancaktepe-mekanik',
        title: 'Ford Sancaktepe Yerleşkesi Deprem Güçlendirme Mekanik İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '25.11.2024',
        endDate: '30.08.2025',
        date: '2024',
        image: image1
    },
    {
        id: 'ford-sancaktepe-elektrik',
        title: 'Ford Sancaktepe Yerleşkesi Deprem Güçlendirme Elektrik İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '25.11.2024',
        endDate: '30.08.2025',
        date: '2024',
        image: image1
    },
    {
        id: 'ford-sancaktepe-insaat',
        title: 'Ford Sancaktepe Yerleşkesi Deprem Güçlendirme İnşaat İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.10.2024',
        endDate: '30.08.2025',
        date: '2024',
        image: image1
    },
    {
        id: 'nidakule-kucukyali',
        title: 'Nidakule Küçükyalı 99/100/101/102 Numaralı İşyeri İnşaat Elektrik Mekanik İşleri',
        subtitle: 'Nascar Araç Kiralama A.Ş.',
        startDate: '02.01.2025',
        endDate: '31.05.2025',
        date: '2025',
        image: image1
    },
    {
        id: 'ford-eskisehir-urge',
        title: 'Ford Eskişehir Ürge Otoparklar Yangın Hidrant Tesisat İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '07.10.2024',
        endDate: '28.02.2025',
        date: '2025',
        image: image1
    },
    {
        id: 'ford-eskisehir-fnc',
        title: 'Ford Otosan Eskişehir FNC Altyapı Boru Tesisatı Deplase ve Revizyon İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.06.2024',
        endDate: '31.01.2025',
        date: '2025',
        image: image1
    },
    {
        id: 'otokoc-beylikduzu',
        title: 'Otokoç Otomotiv Beylikdüzü Birmot Şubesi İnşaat Tadilat İşleri',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '22.11.2024',
        endDate: '31.12.2024',
        date: '2024',
        image: image1
    },
    {
        id: 'bursa-osmangazi-konut',
        title: 'Bursa Osmangazi Bekir Mutlu Konut Projesi',
        subtitle: 'Bekir Mutlu',
        startDate: '01.02.2024',
        endDate: '30.11.2024',
        date: '2024',
        image: image1
    },
    {
        id: 'ford-eskisehir-kurutma',
        title: 'Ford Eskişehir Fabrika Kurutma Kanalı Deplase Projesi İnşaat İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '15.12.2023',
        endDate: '05.07.2024',
        date: '2024',
        image: image1
    },
    {
        id: 'ford-eskisehir-saglik',
        title: 'Ford Otosan Eskişehir Sağlık Merkezi Binası İlave İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '20.03.2024',
        endDate: '31.05.2024',
        date: '2024',
        image: image1
    },
    {
        id: 'otokoc-osmangazi-elektrik',
        title: 'Otokoç Otomotiv Bursa Osmangazi İkinci El Showroom Tadilat Elektrik İşleri',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '01.02.2024',
        endDate: '31.03.2024',
        date: '2024',
        image: image1
    },
    {
        id: 'otokoc-osmangazi-insaat',
        title: 'Otokoç Otomotiv Bursa Osmangazi İkinci El Showroom Tadilat İnşaat İşleri',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '10.01.2024',
        endDate: '31.03.2024',
        date: '2024',
        image: image1
    },
    {
        id: 'ford-eskisehir-lastik',
        title: 'Ford Eskişehir Fabrika Lastik Ambar Binası İnşaat İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '09.08.2023',
        endDate: '31.12.2023',
        date: '2023',
        image: image1
    },
    {
        id: 'ford-eskisehir-compound',
        title: 'Ford Eskişehir Fabrika Compound Sahası Büyüme İşi Kamyon Otopark Alanı',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '20.12.2022',
        endDate: '31.08.2023',
        date: '2023',
        image: image1
    },
    {
        id: 'eskisehir-aritma',
        title: 'Ford Otosan Eskişehir Fabrikası Arıtma Tesisi Evsel Arıtım Sistemi Son Çöktürme Tankı Dış Alan Beton Zemin İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.12.2022',
        endDate: '15.12.2022',
        date: '2022',
        image: image1
    },
    {
        id: 'eskisehir-asfalt',
        title: 'Ford Otosan Eskişehir Fabrikası Dış Saha Hasarlı Yolların Sıcak Asfalt Yama İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '15.10.2022',
        endDate: '05.11.2022',
        date: '2022',
        image: image1
    },
    {
        id: 'eskisehir-inonu-kamyon',
        title: 'Ford Otosan Eskişehir İnönü Tesisi İlave Bina Kamyon Fabrikası Tevsii İnşaatı',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.04.2022',
        endDate: '30.10.2022',
        date: '2022',
        image: image1
    },
    {
        id: 'atasehir-birmot',
        title: 'Otokoç Otomotiv Ataşehir Birmot Showroom Binası Tadilat İşleri',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '07.03.2022',
        endDate: '30.09.2022',
        date: '2022',
        image: image1
    },
    {
        id: 'eskisehir-inonu-dolgu',
        title: 'Ford Otosan Eskişehir İnönü Tesisi İlave Saha Dolgu İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.09.2022',
        endDate: '10.09.2022',
        date: '2022',
        image: image1
    },
    {
        id: 'taysad-arge',
        title: 'Taysad Organize Sanayi Bölgesi Mevcut Fabrika Binası Arge Ofis Tadilat İnşaatı',
        subtitle: 'Cavo Otomotiv A.Ş.',
        startDate: '01.07.2021',
        endDate: '15.12.2021',
        date: '2021',
        image: image1
    },
    {
        id: 'bursa-nilufer-otokoc',
        title: 'Otokoç Otomotiv Bursa Nilüfer Birmot Servis Binası',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '15.08.2020',
        endDate: '25.10.2021',
        date: '2021',
        image: image1
    },
    {
        id: 'ford-golcuk-boyahane',
        title: 'Ford Otosan Gölcük Fabrika Boyahane Sundurma İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '25.07.2020',
        endDate: '30.09.2021',
        date: '2021',
        image: image1
    },
    {
        id: 'sancaktepe-istinat',
        title: 'Ford Otosan Sancaktepe Tesisi İstinat Duvarı İnşaat Yapım İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '25.08.2019',
        endDate: '10.11.2019',
        date: '2019',
        image: image1
    },
    {
        id: 'beylikduzu-birmot',
        title: 'Otokoç Otomotiv Beylikdüzü Birmot Tesis Tadilat İnşaat İşleri',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '01.04.2018',
        endDate: '31.12.2018',
        date: '2018',
        image: image1
    },
    {
        id: 'kucukyali-ilave',
        title: 'Otokoç Otomotiv Küçükyalı Kampüsü İlave Tadilat İşleri',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '01.10.2017',
        endDate: '31.03.2018',
        date: '2018',
        image: image1
    },
    {
        id: 'kucukyali-etap2',
        title: 'Otokoç Otomotiv Küçükyalı Kampüsü İkinci Etap Tadilat İşleri',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '04.01.2017',
        endDate: '31.12.2017',
        date: '2017',
        image: image1
    },
    {
        id: 'golcuk-montaj',
        title: 'Ford Otosan Gölcük Montaj Binası Muhtelif İşler',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '24.04.2017',
        endDate: '21.12.2017',
        date: '2017',
        image: image1
    },
    {
        id: 'inonu-acs',
        title: 'Ford Otosan İnönü Fabrika ACS Binası İnşaat Mekanik Elektrik İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.08.2016',
        endDate: '30.03.2017',
        date: '2017',
        image: image1
    },
    {
        id: 'inonu-kamyon-ambar',
        title: 'Ford Otosan İnönü Fabrika Kamyon Ambarı İkinci Faz Yapım İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '27.04.2016',
        endDate: '31.12.2016',
        date: '2016',
        image: image1
    },
    {
        id: 'kucukyali-etap1',
        title: 'Otokoç Otomotiv Küçükyalı Kampüsü Birinci Etap Tadilat İşleri',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '12.08.2016',
        endDate: '26.12.2016',
        date: '2016',
        image: image1
    },
    {
        id: 'ford-golcuk-ofis',
        title: 'Ford Otosan Gölcük Fabrika Boyahane ve Sosyal Tesis Mevcut Ofis Revizyonları',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.05.2016',
        endDate: '31.08.2016',
        date: '2016',
        image: image1
    },
    {
        id: 'golcuk-boyahane-sosyal',
        title: 'Ford Otosan Gölcük Fabrika Boyahane ve Sosyal Tesis Bina İnşaat İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '21.09.2015',
        endDate: '07.03.2016',
        date: '2016',
        image: image1
    },
    {
        id: 'kartal-pazarlama',
        title: 'Ford Otosan Kartal Fabrika Pazarlama Binası Tadilat İşleri',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '15.08.2014',
        endDate: '31.12.2015',
        date: '2015',
        image: image1
    },
    {
        id: 'yenisahra-plaza',
        title: 'Alper Özbilen Yenisahra Plaza',
        subtitle: 'Alper Özbilen',
        startDate: '20.02.2014',
        endDate: '21.12.2015',
        date: '2015',
        image: image1
    },
    {
        id: 'ford-golcuk-bakim',
        title: 'Ford Otosan Gölcük Fabrika Araç Mühendisliği Yeni Bakım Ofisi',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '08.08.2014',
        endDate: '31.03.2015',
        date: '2015',
        image: image1
    },
    {
        id: 'yalova-topcular',
        title: 'Yalova Topçular İlave Fabrika İnşaatı',
        subtitle: 'Taştanlar Cephe Mimarlık Ltd. Şti.',
        startDate: '01.07.2013',
        endDate: '31.10.2013',
        date: '2013',
        image: image1
    },
    {
        id: 'isletme-atolyesi-2013',
        title: 'İşletme Atölyesi İnşaatı Çelik ve Betonarme Üretim Tesisi',
        subtitle: 'Componenta Dökümcülük A.Ş.',
        startDate: '10.02.2013',
        endDate: '30.08.2013',
        date: '2013',
        image: image1
    },
    {
        id: 'dilman-lojistik-2013',
        title: 'Lojistik Depo Binası İnşaat İşleri Saha Betonu ve İstinat Duvar İşleri',
        subtitle: 'Dilman Lojistik A.Ş.',
        startDate: '15.02.2013',
        endDate: '31.07.2013',
        date: '2013',
        image: image1
    },
    {
        id: 'atasehir-flora',
        title: 'Otokoç Otomotiv Ataşehir Flora Residence Showroom ve Servis İnşaatı',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '01.02.2012',
        endDate: '30.06.2013',
        date: '2013',
        image: image1
    },
    {
        id: 'inonu-kamyon-ince',
        title: 'Eskişehir İnönü Otokoç Kamyon Servisi İnce İşler İnşaatı',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '15.01.2013',
        endDate: '31.05.2013',
        date: '2013',
        image: image1
    },
    {
        id: 'gebze-makina',
        title: 'Gebze Fabrikası Makina Temel İnşaatı ve Çelik İşleri',
        subtitle: 'Omya Madencilik A.Ş.',
        startDate: '01.01.2013',
        endDate: '31.03.2013',
        date: '2013',
        image: image1
    },
    {
        id: 'eskisehir-merkez-otokoc',
        title: 'Eskişehir Merkez Otokoç Özüme Dönüşüm Projesi İnce İşler',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '15.10.2012',
        endDate: '31.12.2012',
        date: '2012',
        image: image1
    },
    {
        id: 'inonu-kamyon-kaba',
        title: 'Eskişehir İnönü Otokoç Kamyon Servisi Kaba İnşaatı',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '25.09.2012',
        endDate: '31.12.2012',
        date: '2012',
        image: image1
    },
    {
        id: 'ford-makine-temeli',
        title: 'Üç Adet Makine Temeli',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '01.12.2012',
        endDate: '30.12.2012',
        date: '2012',
        image: image1
    },
    {
        id: 'gebze-degirmen',
        title: 'Kocaeli Gebze Değirmen Temeli Arakat Betonarme ve Bina Çelik Güçlendirmesi',
        subtitle: 'Omya Madencilik A.Ş.',
        startDate: '01.09.2012',
        endDate: '30.11.2012',
        date: '2012',
        image: image1
    },
    {
        id: 'kurucesme-birmot',
        title: 'Kuruçeşme Otokoç Birmot Tadilat İşleri',
        subtitle: 'Otokoç Otomotiv A.Ş.',
        startDate: '01.07.2012',
        endDate: '31.08.2012',
        date: '2012',
        image: image1
    },
    {
        id: 'cavo-otomotiv-2011',
        title: 'Cavo Otomotiv Oto Parçası Fabrika Binası ve İdari Bina',
        subtitle: 'Cavo Otomotiv A.Ş.',
        startDate: '15.03.2011',
        endDate: '30.06.2012',
        date: '2012',
        image: image1
    },
    {
        id: 'zeytin-isleme-2010',
        title: 'Zeytin İşleme Tesisi Sosyal Tesis ve İdari Bina Yapımı Saha ve Çevre Tanzimi',
        subtitle: 'Ferkay Zeytincilik ve Tedarik A.Ş.',
        startDate: '27.04.2010',
        endDate: '31.12.2010',
        date: '2010',
        image: image1
    },
    {
        id: 'haldun-ata-turan-2008',
        title: 'Haldun Ata Turan Lojistik Binası Betonarme ve Çelik Konstrüksiyon Lojistik ve İdari Bina Saha Betonları',
        subtitle: 'Haldun Ata Turan',
        startDate: '21.02.2008',
        endDate: '24.04.2009',
        date: '2009',
        image: image1
    },
    {
        id: 'zihinsel-engelliler-okulu-2008',
        title: 'Öğretilebilir Zihinsel Engelliler Okulu İnşaatı',
        subtitle: 'Ormo Yün İplik A.Ş.',
        startDate: '01.08.2008',
        endDate: '17.12.2008',
        date: '2008',
        image: image1
    },
    {
        id: 'isletme-atolyesi-2008',
        title: 'İşletme Atölyesi İnşaatı Çelik İşletme Atölyesi Betonarme İdari Binası Beton Yol ve Sahalar',
        subtitle: 'Componenta A.Ş.',
        startDate: '14.01.2008',
        endDate: '31.07.2008',
        date: '2008',
        image: image1
    },
    {
        id: 'dilman-lojistik-2007',
        title: 'Lojistik Depo ve İdari Bina İnşaat İşleri',
        subtitle: 'Dilman Lojistik A.Ş.',
        startDate: '01.09.2007',
        endDate: '15.06.2008',
        date: '2008',
        image: image1
    },
    {
        id: 'otokoc-showroom-2007',
        title: 'Betonarme ve Çelik Çatılı Showroom Binası ve Saha Betonları',
        subtitle: 'Koç Holding A.Ş.',
        startDate: '15.10.2007',
        endDate: '22.04.2008',
        date: '2008',
        image: image1
    },
    {
        id: 'birmot-tadilat-2007',
        title: 'Birmot Birleşik Servisi Tadilat İşleri',
        subtitle: 'Birmot Birleşik Motor A.Ş.',
        startDate: '03.08.2007',
        endDate: '15.02.2008',
        date: '2008',
        image: image1
    },
    {
        id: 'orhangazi-zeytin-2006',
        title: 'Orhangazi Zeytin Ticaret Hali Yapımı',
        subtitle: 'Orhangazi Zeytin Ticaret Hali Toplu İşyeri Yapı Kooperatifi',
        startDate: '01.01.2006',
        endDate: '15.05.2007',
        date: '2007',
        image: image1
    },
    {
        id: 'omya-su-deposu-2006',
        title: 'Betonarme Su Deposu',
        subtitle: 'Omya Madencilik A.Ş.',
        startDate: '04.12.2006',
        endDate: '20.02.2007',
        date: '2007',
        image: image1
    },
    {
        id: 'konya-otokoc-2005',
        title: 'Konya Selçuklu Dikili Taş Ford Otokoç 3S Binası',
        subtitle: 'Ark İnşaat A.Ş.',
        startDate: '28.06.2005',
        endDate: '31.12.2005',
        date: '2005',
        image: image1
    },
    {
        id: 'omya-depo-2005',
        title: 'Depo İnşaatı',
        subtitle: 'Omya Madencilik A.Ş.',
        startDate: '03.05.2005',
        endDate: '31.12.2005',
        date: '2005',
        image: image1
    },
    {
        id: 'kartal-msc-2005',
        title: 'Kartal MSC Binası',
        subtitle: 'Telsim A.Ş.',
        startDate: '24.03.2005',
        endDate: '27.07.2005',
        date: '2005',
        image: image1
    },
    {
        id: 'as-otomotiv-2005',
        title: 'Depo ve İdari Bina İnşaatı',
        subtitle: 'As Otomotiv A.Ş.',
        startDate: '18.03.2005',
        endDate: '18.07.2005',
        date: '2005',
        image: image1
    },
    {
        id: 'ford-otosan-konut-2004',
        title: '50 Adet Dubleks Mesken ve 4 Adet Stüdyo Daire Konut İnşaatı Altyapı ve Çevre Tanzim İşleri',
        subtitle: 'Ford Otosan Çalışanları Yapı Kooperatifi',
        startDate: '01.03.2004',
        endDate: '15.10.2005',
        date: '2005',
        image: image1
    },
    {
        id: 'kartal-yedek-parca-2004',
        title: 'Kartal Yedek Parça Deposu',
        subtitle: 'Ford Otomotiv A.Ş.',
        startDate: '03.06.2004',
        endDate: '31.12.2004',
        date: '2004',
        image: image1
    },
    {
        id: 'jandarma-depo-2002',
        title: 'İstanbul Jandarma İkmal Merkezi Komutanlığı Deposu Bina İnşaat İşleri',
        subtitle: 'Kartal Jandarma İkmal Merkezi Komutanlığı',
        startDate: '24.10.2002',
        endDate: '17.12.2002',
        date: '2002',
        image: image1
    },
    {
        id: 'karacabey-pansiyon-2002',
        title: 'Karacabey Pansiyon Harada 77 Box İlave Ahır ve 2 Adet 250 KVA Trafo Binası',
        subtitle: 'Türkiye Jokey Kulübü',
        startDate: '23.08.2002',
        endDate: '01.12.2002',
        date: '2002',
        image: image1
    },
    {
        id: 'marmaris-aritma-2001',
        title: 'Marmaris İçme Suyu ve Arıtma Tesisi Kaba Yapısı',
        subtitle: 'Vinsan Veziroğlu İnşaat A.Ş.',
        startDate: '30.10.2001',
        endDate: '30.04.2002',
        date: '2002',
        image: image1
    },
    {
        id: 'vehbi-koc-okul-1998',
        title: 'Vehbi Koç Vakfı İlköğretim Okulu İnönü Eskişehir',
        subtitle: 'Vehbi Koç Vakfı',
        startDate: '22.12.1998',
        endDate: '12.08.1999',
        date: '1999',
        image: image1
    },
    {
        id: 'otosan-depo-1-1997',
        title: 'Otosan Yedek Parça Deposu ve İdari Bina İnşaatı ve Yol Betonları',
        subtitle: 'Garanti Koza İnşaat A.Ş.',
        startDate: '18.06.1997',
        endDate: '31.12.1997',
        date: '1997',
        image: image1
    },
    {
        id: 'otosan-depo-2-1997',
        title: 'Otosan Yedek Parça Deposu ve İdari Bina İnşaatı ve Yol Betonları',
        subtitle: 'Garanti Koza İnşaat A.Ş.',
        startDate: '10.06.1997',
        endDate: '30.09.1997',
        date: '1997',
        image: image1
    },
    {
        id: 'otosan-depo-3-1997',
        title: 'Otosan Yedek Parça Deposu ve İdari Bina İnşaatı Temel Hatıl ve Perde İmalat Montaj İşi',
        subtitle: 'Garanti Koza İnşaat A.Ş.',
        startDate: '28.03.1997',
        endDate: '30.09.1997',
        date: '1997',
        image: image1
    }
];
export default historyData;